import {
  CardContent,
  Chip,
  Grid,
  Typography,
  TableHead,
  Tooltip,
  IconButton,
  Pagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  CircularProgress,
  TextField,
} from "@mui/material";
import {
  AdminTitleHolder,
  CustomDocumentLink,
} from "../../../common/sharedComponents/styles/card.style";
import {
  CustomTableContainer,
  // TableHeaderFont,
} from "../../../styles/tableContent.style";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { styled as materialStyles } from "@mui/material/styles";
import Card from "@mui/material/Card";
import styled from "styled-components";
import moment from "moment";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import InfoIcon from "@mui/icons-material/Info";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import {
  asnApproveReject,
  getArnDetails,
  getUserAsnDetails,
} from "../redux/asnModuleSlice";
import { RemoveRedEye } from "@mui/icons-material";
import {
  ApproveButton,
  RejectButton,
} from "../../vendorRegistration/components/ViewvendorDetails";
import { message } from "antd";

function AsnModuleViewContent() {
  const {
    user_asn_details,
    loading,
    aprrove_reject_loading,
    view_arn_details_loading,
    viewArnDetails: viewArnData,
  } = useSelector((state) => state.asnModule);

  const params = useParams();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [arn_page, setArn_Page] = useState(1);
  const [arn_perPage, setArn_PerPage] = useState(10);
  const [viewModal, setViewModal] = useState(false);
  const [viewItemDetails, setViewItemDetails] = useState(null);
  const [open, setOpen] = React.useState(false);
  const [openRej, setOpenRej] = React.useState(false);
  const [rejectReason, setRejectReason] = useState(null);

  const arnItemColumns = [
    { key: "srNo", label: "Sr. No." },
    { key: "MaterialCode", label: "Item Code" },
    { key: "Description", label: "Item Name" },
    { key: "quantity", label: "PO Quantity" },
    { key: "uom", label: "UOM" },
    // { key: "unit_price", label: "Rate" },
    { key: "quantity", label: "ASN Quantity" },
    { key: "accepted_quantity", label: "Accepted Quantity" },
    { key: "rejected_quantity", label: "Rejected Quantity" },
    { key: "action", label: "Action" },
  ];
  const viewItemFields = [
    { label: "ITEM CODE", key: "MaterialCode" },
    { label: "ITEM NAME", key: "Description" },
    { label: "UNIT OF MEASUREMENT", key: "uom" },
    { label: "PO QUANTITY", key: "quantity" },
    { label: "ITEM DESCRIPTION", key: "LongDescription" },
    { label: "REMARK", key: "remark" },
    { label: "ACCEPTED QUANTITY", key: "accepted_quantity" },
    { label: "REJECTED QUANTITY", key: "rejected_quantity" },
    { label: "ASN QUANTITY", key: "quantity" },
    // { label: "DISCOUNT IN %", key: "discount" },
    // { label: "UNIT RATE", key: "unit_price" },
    // { label: "TOTAL RATE", key: "unit_total_price" },
    { label: "LOCATIONS", key: "location" },
    // { label: "GST TYPES", key: "gst_type" },
    // { label: "GST IN %", key: "gst_per" },
    {
      label: "DATE OF DELIVERY",
      key: "delievery_date",
      formatter: (value) => value ? moment(value).format("DD MMM YYYY") : "Not Applicable",
    },
  ];
  const itemColumns = [
    { key: "srNo", label: "Sr. No." },
    { key: "MaterialCode", label: "Item Code" },
    { key: "Description", label: "Item Name" },
    { key: "quantity", label: "PO Quantity" },
    { key: "remaining_quentity", label: "Remaining Quantity" },
    { key: "quantity", label: "ASN Quantity" },
    { key: "uom", label: "UOM" },
    // { key: "unit_price", label: "Rate" },
    { key: "action", label: "Action" },
  ];

  const asn_id = params.asnid;
  const viewAsnDetails = (asn_id) => {
    dispatch(
      getUserAsnDetails({ asn_id: asn_id, page: page, per_page: perPage })
    );
  };
  const viewArnDetails = (asn_id) => {
    dispatch(
      getArnDetails({ asn_id: asn_id, page: arn_page, per_page: arn_perPage })
    );
  };
  const handleViewModalOpen = (itemID, type) => {
    setViewModal(true);
    if (itemID) {
      if (type === "asn") {
        const item = user_asn_details?.AsnMaterials?.data?.find(
          (item) => item?.OrderMaterial?.MaterialMaster?.MaterialCode === itemID
        );
        setViewItemDetails(item);
      } else if (type === "arn") {
        const item = viewArnData?.Arn_Materials?.data?.find(
          (item) =>
            item?.AsnMaterial?.OrderMaterial?.MaterialMaster?.MaterialCode ===
            itemID
        );
        setViewItemDetails({
          ...item?.AsnMaterial,
          accepted_quantity: item?.accepted_quantity,
          rejected_quantity: item?.rejected_quantity,
          remark: item?.remark,
          OrderMaterial: {
            ...item?.AsnMaterial?.OrderMaterial,
            MaterialMaster: {
              ...item?.AsnMaterial?.OrderMaterial?.MaterialMaster,
              LongDescription:
                item?.AsnMaterial?.OrderMaterial?.item_description,
            },
          },
        });
      }
    }
  };
  const handleViewModalClose = () => {
    setViewModal(false);
    setViewItemDetails(null);
  };
  const handleChangeRowsPerPage = (event) => {
    setPerPage(event);
    setPage(1);
  };
  const handleArnChangeRowsPerPage = (event) => {
    setArn_PerPage(event);
    setArn_Page(1);
  };

  useEffect(() => {
    viewAsnDetails(asn_id);
    // eslint-disable-next-line
  }, [page, perPage]);

  useEffect(() => {
    viewArnDetails(asn_id);
    // eslint-disable-next-line
  }, [arn_page, arn_perPage]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleClickOpenReject = () => {
    setOpenRej(true);
  };
  const handleCloseRej = () => {
    setOpenRej(false);
    setRejectReason(null);
  };
  const handleApproveAsn = (type) => {
    try {
      dispatch(
        asnApproveReject({
          asn_id: asn_id,
          is_accpet: type === "reject" ? false : true,
          reason: type === "reject" ? rejectReason : "",
        })
      ).then((response) => {
        if (response.payload.success) {
          setOpen(false);
          setOpenRej(false);
          setRejectReason(null);
          viewAsnDetails(asn_id);
        } else {
          setOpenRej(false);
          setOpen(false);
        }
      });
    } catch (error) {
      message.error(error);
    }
  };
  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Please Confirm"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to approve this ans?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            variant="outlined"
            style={{
              borderColor: "rgb(28 182 151)",
              color: "#0f0f0f",
            }}
            size="small"
            // color="success"
          >
            Cancel
          </Button>
          <ApproveButton
            variant="contained"
            style={{
              float: "right",
              backgroundColor: "var(--button-color)",
              color: "white",
            }}
            onClick={(e) => handleApproveAsn("approve")}
            autoFocus
            size="small"
            disabled={aprrove_reject_loading}
          >
            {aprrove_reject_loading ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              "Approve"
            )}
          </ApproveButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openRej}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Please Confirm"}</DialogTitle>
        <DialogContent
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "5px",
          }}
        >
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to reject this asn?
          </DialogContentText>
          <div style={{ width: "100%" }}>
            <TextField
              multiline
              rows={4}
              placeholder="Enter Reject Reason"
              style={{
                width: "100%",
                paddingTop: "3px",
                fontSize: "8px",
                fontFamily: "var(--font-family-reg)",
              }}
              fullWidth
              value={rejectReason}
              onChange={(e) => setRejectReason(e.target.value)}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseRej}
            variant="outlined"
            style={{
              borderColor: "rgb(211 47 47)",
              color: "#0f0f0f",
            }}
            size="small"
          >
            Cancel
          </Button>
          <RejectButton
            color="error"
            variant="contained"
            style={{
              float: "right",
            }}
            onClick={(e) => handleApproveAsn("reject")}
            autoFocus
            size="small"
            disabled={aprrove_reject_loading}
          >
            {aprrove_reject_loading ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              "Reject"
            )}
          </RejectButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={viewModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="lg"
        fullWidth
        onClose={handleViewModalClose}
      >
        <DialogTitle id="alert-dialog-title">
          {`Item #${viewItemDetails?.OrderMaterial?.MaterialMaster?.MaterialCode}`}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Grid container spacing={4}>
              {viewItemDetails &&
                viewItemFields
                  .filter(
                    (field) =>
                      !(
                        field.key === "accepted_quantity" &&
                        !viewItemDetails?.accepted_quantity
                      ) &&
                      !(
                        field.key === "rejected_quantity" &&
                        !viewItemDetails?.rejected_quantity
                      ) &&
                      !(field.key === "remark" && !viewItemDetails?.remark)
                  )
                  .map((field) => (
                    <Grid
                      item
                      xs={
                        field?.label === "ITEM DESCRIPTION" ||
                        field?.label === "REMARK"
                          ? 12
                          : 3
                      }
                      md={
                        field?.label === "ITEM DESCRIPTION" ||
                        field?.label === "REMARK"
                          ? 12
                          : 3
                      }
                    >
                      <Typography className="label">{field.label}</Typography>
                      <VendorCardLabel>
                        {field.formatter
                          ? field.formatter(
                              viewItemDetails?.OrderMaterial?.[field.key]
                            )
                          : field.label === "ITEM DESCRIPTION" ||
                            field.label === "ITEM CODE" ||
                            field.label === "ITEM NAME"
                          ? viewItemDetails?.OrderMaterial?.MaterialMaster?.[
                              field.key
                            ]
                          : field.label === "ASN QUANTITY"
                          ? viewItemDetails?.[field.key]
                          : field.key === "accepted_quantity" ||
                            field.key === "rejected_quantity" ||
                            field.key === "remark"
                          ? viewItemDetails?.[field.key]
                          : viewItemDetails?.OrderMaterial?.[field.key]}
                      </VendorCardLabel>
                    </Grid>
                  ))}
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleViewModalClose}
            variant="outlined"
            style={{
              borderColor: "var(--button-color)",
              color: "black",
            }}
            size="small"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      {loading || view_arn_details_loading ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          <AdminTitleHolder>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                Advanced Shipping Notice#
                {user_asn_details.asn_number
                  ? user_asn_details.asn_number
                  : "Not Applicable"}
              </Grid>
              {user_asn_details?.is_approver === true ? (
                <Grid item xs={6}>
                  {" "}
                  <ApproveButton
                    onClick={handleClickOpen}
                    variant="outlined"
                    color="success"
                    style={{
                      height: "40px",
                      width: "150px",
                      float: "right",
                    }}
                  >
                    Approve
                  </ApproveButton>
                  <RejectButton
                    onClick={handleClickOpenReject}
                    variant="outlined"
                    color="error"
                    style={{
                      height: "40px",
                      width: "150px",
                      float: "right",
                      marginInline: "1rem",
                    }}
                  >
                    Reject
                  </RejectButton>
                </Grid>
              ) : user_asn_details?.status === "Accepted" ? (
                <Grid item xs={6}>
                  <Chip
                    style={{
                      /*  height: "40px", */
                      width: "100px",
                      borderRadius: "25px",
                      backgroundColor: "var(--button-color)",
                      color: "white",
                      float: "right",
                    }}
                    label="Accepted"
                  />
                </Grid>
              ) : user_asn_details?.status === "Rejected" ? (
                <Grid item xs={6}>
                  <Chip
                    style={{
                      /*  height: "40px", */
                      width: "100px",
                      borderRadius: "25px",
                      backgroundColor: "#d32f2f",
                      color: "white",
                      float: "right",
                    }}
                    label="Rejected"
                  />
                </Grid>
              ) : (
                <Grid item xs={6}>
                  <Chip
                    style={{
                      /*  height: "40px", */
                      width: "100px",
                      borderRadius: "25px",
                      backgroundColor: "#ed6c02",
                      color: "white",
                      float: "right",
                    }}
                    label="Pending"
                  />
                </Grid>
              )}
            </Grid>
          </AdminTitleHolder>
          <StyledCard>
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={6} md={6}>
                  <Typography className="label">
                    PURCHASE ORDER NUMBER
                  </Typography>
                  <VendorCardLabel>
                    {user_asn_details?.Order?.order_number
                      ? user_asn_details?.Order?.order_number
                      : "Not Applicable"}
                  </VendorCardLabel>
                </Grid>

                <Grid item xs={6} md={6}>
                  <Typography className="label">ASN NUMBER</Typography>
                  <VendorCardLabel>
                    {user_asn_details.asn_number
                      ? user_asn_details.asn_number
                      : "Not Applicable"}
                  </VendorCardLabel>
                </Grid>
                <Grid item xs={6} md={6}>
                  <Typography className="label">ASN DATE</Typography>
                  <VendorCardLabel>
                    {user_asn_details.asn_date
                      ? moment(user_asn_details.asn_date).format("DD MMM YY")
                      : "Not Applicable"}
                  </VendorCardLabel>
                </Grid>

                <Grid item xs={6} md={6}>
                  <Typography className="label">SHIPMENT DATE</Typography>
                  <VendorCardLabel>
                    {user_asn_details.shipment_date
                      ? moment(user_asn_details.shipment_date).format(
                          "DD MMM YY"
                        )
                      : "Not Applicable"}
                  </VendorCardLabel>
                </Grid>
                <Grid item xs={6} md={6}>
                  <Typography className="label">
                    ESTIMATED ARRIVAL DATE
                  </Typography>
                  <VendorCardLabel>
                    {user_asn_details.estimeted_arrival_date
                      ? moment(user_asn_details.estimeted_arrival_date).format(
                          "DD MMM YY"
                        )
                      : "Not Applicable"}
                  </VendorCardLabel>
                </Grid>
              </Grid>
              <br />
              <br />
              <VendorCardTitle>Carrier Details</VendorCardTitle>
              <Grid container spacing={2}>
                <Grid item xs={6} md={6}>
                  <Typography className="label">CARRIER NAME</Typography>
                  <VendorCardLabel>
                    {user_asn_details.carrier_name
                      ? user_asn_details.carrier_name
                      : "Not Applicable"}
                  </VendorCardLabel>
                </Grid>
                <Grid item xs={6} md={6}>
                  <Typography className="label">TRACKING NUMBER</Typography>
                  <VendorCardLabel>
                    {user_asn_details.carrier_tracking_number
                      ? user_asn_details.carrier_tracking_number
                      : "Not Applicable"}
                  </VendorCardLabel>
                </Grid>
                <Grid item xs={6} md={6}>
                  <Typography className="label">SHIPPING METHOD</Typography>
                  <VendorCardLabel>
                    {user_asn_details.carrier_shopping_method
                      ? user_asn_details.carrier_shopping_method
                      : "Not Applicable"}
                  </VendorCardLabel>
                </Grid>
              </Grid>
              <br />
              <br />
              <VendorCardTitle>Contact Person Details</VendorCardTitle>
              <Grid container spacing={2}>
                <Grid item xs={6} md={6}>
                  <Typography className="label">PERSON NAME</Typography>
                  <VendorCardLabel>
                    {user_asn_details.contact_person_name
                      ? user_asn_details.contact_person_name
                      : "Not Applicable"}
                  </VendorCardLabel>
                </Grid>
                <Grid item xs={6} md={6}>
                  <Typography className="label">CONTACT NUMBER</Typography>
                  <VendorCardLabel>
                    {user_asn_details.contact_person_email
                      ? user_asn_details.contact_person_email
                      : "Not Applicable"}
                  </VendorCardLabel>
                </Grid>
              </Grid>
              <br />
              <br />
              <VendorCardTitle>Item Details</VendorCardTitle>
              {user_asn_details?.AsnMaterials?.data?.length ? (
                <CustomTableContainer component={Card}>
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow
                        style={{
                          backgroundColor: "#e1ebfa",
                        }}
                      >
                        {itemColumns.map((column, index) => (
                          <TableCell
                            key={index}
                            style={{ fontWeight: "bold", fontSize: "14px" }}
                          >
                            {column?.label}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {user_asn_details?.AsnMaterials?.data?.map(
                        (item, index) => (
                          <TableRow
                            key={index}
                            style={{
                              backgroundColor: "#fafcff",
                            }}
                          >
                            {itemColumns.map((column) => (
                              <>
                                <TableCell
                                  key={column.key}
                                  style={{
                                    fontFamily: "var(--font-family-reg)",
                                    fontSize: "12px",
                                    textAlign: column.align || "left",
                                    color:
                                      column?.key === "Description"
                                        ? "#0000FF"
                                        : "inherit",
                                  }}
                                >
                                  {column?.key === "srNo" ? (
                                    index + 1
                                  ) : column?.key === "Description" ? (
                                    <Tooltip
                                      arrow
                                      title={
                                        item?.OrderMaterial?.MaterialMaster
                                          ?.LongDescription ||
                                        "No description available"
                                      }
                                    >
                                      <span>
                                        {
                                          item?.OrderMaterial?.MaterialMaster?.[
                                            column?.key
                                          ]
                                        }
                                      </span>
                                    </Tooltip>
                                  ) : column?.key === "action" ? (
                                    <Tooltip title="View Item">
                                      <IconButton aria-label="view">
                                        <RemoveRedEye
                                          style={{
                                            fill: "royalblue",
                                            height: "18px",
                                            width: "18px",
                                          }}
                                          onClick={() =>
                                            handleViewModalOpen(
                                              item?.OrderMaterial
                                                ?.MaterialMaster?.[
                                                "MaterialCode"
                                              ],
                                              "asn"
                                            )
                                          }
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  ) : column?.key === "MaterialCode" ? (
                                    item?.OrderMaterial?.MaterialMaster?.[
                                      column?.key
                                    ]
                                  ) : column?.label === "ASN Quantity" ? (
                                    item?.[column?.key]
                                  ) : item?.OrderMaterial?.[column?.key] ? (
                                    item?.OrderMaterial?.[column?.key]
                                  ) : (
                                    "-"
                                  )}
                                </TableCell>
                              </>
                            ))}
                          </TableRow>
                        )
                      )}
                    </TableBody>
                  </Table>
                  <Grid
                    container
                    className="d-flex flex-row align-items-center justify-content-between w-100 px-3 text-muted"
                    sx={{ height: "8vh", borderTop: "1px solid lightgray" }}
                  >
                    <Grid className="d-flex align-items-center gap-2">
                      <span>Rows per page: </span>
                      <select
                        value={perPage}
                        onChange={(e) =>
                          handleChangeRowsPerPage(e.target.value)
                        }
                      >
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </select>
                    </Grid>
                    <Pagination
                      sx={{
                        width: "max-content",
                      }}
                      color="primary"
                      variant="text"
                      onChange={(_, newValue) => setPage(newValue)}
                      count={
                        user_asn_details?.AsnMaterials?.pagination?.total_page
                      }
                      page={page}
                      shape="rounded"
                      showFirstButton
                      showLastButton
                    />
                  </Grid>
                </CustomTableContainer>
              ) : (
                <Typography className="label">
                  No item added yet. Start by adding an item.
                </Typography>
              )}
              <br />
              <br />
              <VendorCardTitle>ASN Documents</VendorCardTitle>

              <Grid container spacing={2}>
                <Grid item xs={6} md={6}>
                  <Typography className="label">ASN Documents</Typography>
                  {user_asn_details.Asn_documents !== undefined &&
                  user_asn_details.Asn_documents !== null &&
                  user_asn_details.Asn_documents.length > 0 ? (
                    user_asn_details.Asn_documents.map((item, index) => (
                      <VendorCardLabel key={index}>
                        <Tooltip title="Download Document">
                          <CustomDocumentLink
                            href={item?.document_url}
                            target="_blank"
                          >
                            <InsertDriveFileOutlinedIcon
                              style={{
                                marginTop: "-1px",
                                marginRight: "3px",
                                height: "12px",
                                width: "12px",
                              }}
                            />
                            {item?.document_title}
                          </CustomDocumentLink>
                        </Tooltip>
                      </VendorCardLabel>
                    ))
                  ) : (
                    <Typography className="label">
                      <InfoIcon
                        sx={{
                          marginTop: "-1px",
                          marginRight: "1px",
                          fill: "grey",
                          height: "15px",
                          width: "15px",
                        }}
                      />{" "}
                      There are no ASN documents
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </CardContent>
          </StyledCard>
          <StyledCard>
            <CardContent>
              <VendorCardTitle style={{ paddingBottom: "20px" }}>
                ARN Details
              </VendorCardTitle>
              {viewArnData?.Arn_Materials?.data?.length ? (
                <CustomTableContainer component={Card}>
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow
                        style={{
                          backgroundColor: "#e1ebfa",
                        }}
                      >
                        {arnItemColumns.map((column, index) => (
                          <TableCell
                            key={index}
                            style={{ fontWeight: "bold", fontSize: "14px" }}
                          >
                            {column?.label}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {viewArnData?.Arn_Materials?.data?.map((item, index) => (
                        <TableRow
                          key={index}
                          style={{
                            backgroundColor: "#fafcff",
                          }}
                        >
                          {arnItemColumns.map((column) => (
                            <>
                              <TableCell
                                key={column.key}
                                style={{
                                  fontFamily: "var(--font-family-reg)",
                                  fontSize: "12px",
                                  textAlign: column.align || "left",
                                  color:
                                    column?.key === "Description"
                                      ? "#0000FF"
                                      : "inherit",
                                }}
                              >
                                {column?.key === "srNo" ? (
                                  index + 1
                                ) : column?.key === "action" ? (
                                  <Tooltip title="View Item">
                                    <IconButton aria-label="view">
                                      <RemoveRedEye
                                        style={{
                                          fill: "royalblue",
                                          height: "18px",
                                          width: "18px",
                                        }}
                                        onClick={() =>
                                          handleViewModalOpen(
                                            item?.AsnMaterial?.OrderMaterial
                                              ?.MaterialMaster?.[
                                              "MaterialCode"
                                            ],
                                            "arn"
                                          )
                                        }
                                      />
                                    </IconButton>
                                  </Tooltip>
                                ) : column?.key === "Description" ? (
                                  <Tooltip
                                    arrow
                                    title={
                                      item?.AsnMaterial?.OrderMaterial
                                        ?.item_description ||
                                      "No description available"
                                    }
                                  >
                                    <span>
                                      {
                                        item?.AsnMaterial?.OrderMaterial
                                          ?.MaterialMaster?.[column?.key]
                                      }
                                    </span>
                                  </Tooltip>
                                ) : column?.key === "accepted_quantity" ||
                                  column?.key === "rejected_quantity" ? (
                                  item?.[column?.key]
                                ) : column?.label === "ASN Quantity" ? (
                                  item?.AsnMaterial?.[column?.key]
                                ) : column?.key === "MaterialCode" ? (
                                  item?.AsnMaterial?.OrderMaterial
                                    ?.MaterialMaster?.[column?.key]
                                ) : item?.AsnMaterial?.OrderMaterial?.[
                                    column?.key
                                  ] ? (
                                  item?.AsnMaterial?.OrderMaterial?.[
                                    column?.key
                                  ]
                                ) : (
                                  "-"
                                )}
                              </TableCell>
                            </>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  <Grid
                    container
                    className="d-flex flex-row align-items-center justify-content-between w-100 px-3 text-muted"
                    sx={{ height: "8vh", borderTop: "1px solid lightgray" }}
                  >
                    <Grid className="d-flex align-items-center gap-2">
                      <span>Rows per page: </span>
                      <select
                        value={arn_perPage}
                        onChange={(e) =>
                          handleArnChangeRowsPerPage(e.target.value)
                        }
                      >
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </select>
                    </Grid>
                    <Pagination
                      sx={{
                        width: "max-content",
                      }}
                      color="primary"
                      variant="text"
                      onChange={(_, newValue) => setArn_Page(newValue)}
                      count={viewArnData?.Arn_Materials?.pagination?.total_page}
                      page={arn_page}
                      shape="rounded"
                      showFirstButton
                      showLastButton
                    />
                  </Grid>
                </CustomTableContainer>
              ) : (
                <Typography className="label">
                  No item added yet. Start by adding an item.
                </Typography>
              )}
              <br />
              <br />
              <VendorCardTitle>ARN Documents</VendorCardTitle>

              <Grid container spacing={2}>
                <Grid item xs={6} md={6}>
                  <Typography className="label">ARN Documents</Typography>
                  {viewArnData?.ARN_documents !== undefined &&
                  viewArnData?.ARN_documents !== null &&
                  viewArnData?.ARN_documents.length > 0 ? (
                    viewArnData?.ARN_documents.map((item, index) => (
                      <VendorCardLabel key={index}>
                        <Tooltip title="Download Document">
                          <CustomDocumentLink
                            href={item?.document_url}
                            target="_blank"
                          >
                            <InsertDriveFileOutlinedIcon
                              style={{
                                marginTop: "-1px",
                                marginRight: "3px",
                                height: "12px",
                                width: "12px",
                              }}
                            />
                            {item?.document_title}
                          </CustomDocumentLink>
                        </Tooltip>
                      </VendorCardLabel>
                    ))
                  ) : (
                    <Typography className="label">
                      <InfoIcon
                        sx={{
                          marginTop: "-1px",
                          marginRight: "1px",
                          fill: "grey",
                          height: "15px",
                          width: "15px",
                        }}
                      />{" "}
                      There are no ARN documents
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </CardContent>
          </StyledCard>
        </>
      )}
    </>
  );
}

export default AsnModuleViewContent;

export const StyledCard = materialStyles(Card)`
  box-shadow: 0px 0px 20px rgba(127, 161, 250, 0.15);
  flex-direction: column;
  border: none;
  width: 100%;
  height: auto;
  border-radius: 10px;
  margin-bottom: 1em;
  `;

export const VendorCardLabel = styled.div`
  font-family: var(--font-family-reg);
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #32324d;
`;

export const VendorCardTitle = styled.div`
  text-align: left;
  padding: 0px 20px 15px 0px;
  font-family: var(--font-family-semi-bold);
  font-weight: 600;
  font-size: 18px;
  color: #212134;
`;
